import { ApplyModes, BaseAPI, FormAPI } from 'lecom-api';
import ProcessStore from 'process/reflux/process_store';
import ProcessStoreItem from 'process/models/process_store_item';

import { getClassProperties } from 'utils/object_utils';

/**
 * @class ProcessAPI
 * @extends BaseAPI
 */
export default class ProcessAPI extends BaseAPI {
	static applyMode = BaseAPI.applyMode;

	/**
	 * @static
	 * @param {*} processIds
	 * @param {*} applyMode
	 */
	static process(processIds, applyMode = ProcessAPI.applyMode) {
		return new ProcessAPI({ processIds, applyMode });
	}

	/**
	 * @static
	 */
	static currentProcess() {
		const { store } = ProcessStore;
		const currentProcessStoreItem = store[Object.keys(store).find((storeId) => {
			const storeItem = store[storeId];
			return storeItem.isCurrentProcess;
		})];

		if (currentProcessStoreItem) {
			const processApi = ProcessAPI.process(currentProcessStoreItem.processIds);
			window.ProcessData = processApi.processInstanceData();
			window.Form = processApi.form();
			return processApi;
		}
		return null;
	}

	/**
	 * @static
	 */
	static processProperties() {
		return getClassProperties(ProcessStoreItem);
	}

	/**
	 * @constructor
	 * @param {*} param0
	 */
	constructor({ processIds, storeId, applyMode }) {
		super({ id: processIds, storeId, applyMode, storeClass: ProcessStore });

		ProcessAPI.processProperties().forEach((processProperty) => {
			this[processProperty] = this._propertyAccessor.bind(this, processProperty);
		});
	}

	/**
	 *
	 */
	form() {
		return FormAPI.form(this.formStoreId());
	}

	/**
	 *
	 * @param {*} processIds
	 */
	loadProcessInstanceData(processIds = null) {
		const storeActions = this.storeClass.listenables;
		const storeEvents = this.storeClass.events;

		storeActions.loadProcessInstanceData(this.storeId, processIds);
		return this._buildEventPromise(storeEvents.LOAD_PROCESS_INSTANCE_DATA_SUCCESS, storeEvents.LOAD_PROCESS_INSTANCE_DATA_ERROR);
	}

	/**
	 *
	 */
	save() {
		const storeActions = this.storeClass.listenables;
		const storeEvents = this.storeClass.events;

		storeActions.saveActivity(this.storeId);
		return this._buildEventPromise(storeEvents.ACTIVITY_FORM_SAVE_SUCCESS, storeEvents.ACTIVITY_FORM_SAVE_ERROR);
	}

	/**
	 * @private
	 */
	_getStoreItemId() {
		const { store } = this.storeClass;

		return Object.keys(store).find((storeId) => {
			const storeItem = store[storeId];
			let processIds = storeItem.processIds;
			if  (processIds.activityInstanceId === this.id.activityInstanceId && processIds.cycle === this.id.cycle && processIds.processInstanceId === this.id.processInstanceId) {
				return storeItem.processIds;
			}
		});
	}
};
